<template>
  <Photocopy/>
</template>

<script>
import Photocopy from './components/Photocopy.vue'

export default {
  name: 'App',
  components: {
    Photocopy
  }
}
</script>

<style>
#app {
  margin: 30px;
}
</style>
